import { useGetConfusionMatrix } from './useGetConfusionMatrix'
import { useGetPredictionMistakes } from './useGetPredictionMistakes'

export const metrics = {
  getPredictionMistakes: useGetPredictionMistakes,
  getConfusionMatrix: useGetConfusionMatrix,
}
